// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1xQLL","footer":"Form_footer__-5cqR"};